// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e9ww","fullView":"styles_fullView__3invT"};